import { DEFAULT_TRAVEL_MODE } from 'shared/constants/map';

export default google => (
  origin,
  destination,
  travelMode = DEFAULT_TRAVEL_MODE
) => {
  const DirectionsService = new google.maps.DirectionsService();

  return new Promise((resolve, reject) => {
    DirectionsService.route(
      {
        origin,
        destination,
        travelMode: google.maps.TravelMode[travelMode]
      },
      (result, status) => {
        if (status === google.maps.DirectionsStatus.OK) {
          resolve(result);
        }
        reject(result);
      }
    );
  });
};
